export default __webpack_public_path__ + "static/adventure-store-bd1e5dcc766a077113c784b9e14ba758.png";